import { render, staticRenderFns } from "./BasicCard.vue?vue&type=template&id=0256ac08&scoped=true&"
import script from "./BasicCard.vue?vue&type=script&lang=js&"
export * from "./BasicCard.vue?vue&type=script&lang=js&"
import style0 from "./BasicCard.vue?vue&type=style&index=0&id=0256ac08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0256ac08",
  null
  
)

export default component.exports